import React, { useEffect, useState } from 'react';

interface Particle {
  id: number;
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  color: string;
}

interface ParticleEffectsProps {
  x: number;
  y: number;
  trigger: boolean;
  onComplete: () => void;
}

export const ParticleEffects: React.FC<ParticleEffectsProps> = ({ x, y, trigger, onComplete }) => {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    if (!trigger) return;

    // Create initial particles
    const newParticles: Particle[] = [];
    const colors = ['#ec4899', '#f472b6', '#fbbf24', '#60a5fa', '#34d399'];
    
    for (let i = 0; i < 15; i++) {
      newParticles.push({
        id: i,
        x: 0,
        y: 0,
        vx: (Math.random() - 0.5) * 8,
        vy: (Math.random() - 0.5) * 8,
        life: 1,
        color: colors[Math.floor(Math.random() * colors.length)]
      });
    }
    
    setParticles(newParticles);

    // Animate particles
    const interval = setInterval(() => {
      setParticles(prev => {
        const updated = prev.map(particle => ({
          ...particle,
          x: particle.x + particle.vx,
          y: particle.y + particle.vy,
          vy: particle.vy + 0.3, // gravity
          life: particle.life - 0.05
        })).filter(particle => particle.life > 0);

        if (updated.length === 0) {
          clearInterval(interval);
          onComplete();
        }

        return updated;
      });
    }, 16);

    return () => clearInterval(interval);
  }, [trigger, onComplete]);

  if (!trigger || particles.length === 0) return null;

  return (
    <div 
      className="fixed pointer-events-none z-50"
      style={{ left: x, top: y }}
    >
      {particles.map(particle => (
        <div
          key={particle.id}
          className="absolute w-2 h-2 rounded-full"
          style={{
            backgroundColor: particle.color,
            transform: `translate(${particle.x}px, ${particle.y}px)`,
            opacity: particle.life,
            boxShadow: `0 0 6px ${particle.color}`
          }}
        />
      ))}
    </div>
  );
}; 